import { ResponsePio } from '../../shared/interfaces';
import { createReducer, on } from '@ngrx/store';
import { PioActions } from '../actions';
import { PioTypes } from '../../shared/enums';

export interface PioState {
    response: ResponsePio;
    request: any;
    error: any;
}

export const PioInitialState: PioState = {
    response: null,
    request: null,
    error: null
};

const _pioReducer = createReducer(
    PioInitialState,

    on(PioActions.getPio, (state) => ({
        ...state,
        request: null,
        error: null
    })),

    on(PioActions.getPioSucess, (state, { response }) => ({
        ...state,
        response,
        error: null
    })),

    on(PioActions.getPioError, (state, { payload }) => ({
        ...state,
        request: null,
        response: null,
        error: {
            statusCode: payload.statusCode,
            message: payload.message
        }
    })),

    on(PioActions.cleanState, (state) => ({
        ...state,
        request: null,
        response: null,
        error: null
    }))
);

export function pioReducer(state, action) {
    if (action.type === PioTypes.PIO) {
        state = undefined;
    }
    return _pioReducer(state, action);
}
